import { BaseDesignOption } from '@/modules/ta/reportstudio/models/element/metadata/BaseDesignOption';
import {
  ReportElementTextDesignOption,
  ReportElementDesignOption,
} from '@/modules/ta/reportstudio/reportstudio.constants';

export class TextDesignOption extends BaseDesignOption {
  /**
   * @type {boolean}
   */
  show_on_every_page;

  /**
   * @type {string}
   */
  text;

  /**
   * @type {string}
   */
  text_align;

  /**
   * @type {string}
   */
  vertical_alignment;

  /**
   * @type {number}
   */
  font_size;

  /**
   * @type {string}
   */
  font_family;

  /**
   * @type {string}
   */
  text_padding;

  /**
   * @type {string}
   */
  text_color;

  /**
   * @type {boolean}
   */
  text_bold;

  /**
   * @type {boolean}
   */
  text_italic;

  /**
   * @type {boolean}
   */
  text_underline;

  /**
   * @type {boolean}
   */
  text_strikethrough;

  /**
   * @type {number}
   */
  text_opacity;

  /**
   * @type {string}
   */
  text_shadow_color;

  /**
   * @type {number}
   */
  text_shadow_blur;

  /**
   * @type {number}
   */
  text_shadow_x;

  /**
   * @type {number}
   */
  text_shadow_y;

  constructor(model = {}) {
    super();
    this.show_on_every_page = model.show_on_every_page ?? true;
    this.text = model.text ?? ReportElementTextDesignOption.TEXT_EMPTY_PLACEHOLDER;
    this.text_align = model.text_align ?? ReportElementDesignOption.TEXT_ALIGNMENT.CENTER;
    this.vertical_alignment =
      model.vertical_alignment ?? ReportElementDesignOption.VERTICAL_ALIGNMENT.CENTER;
    this.font_size = model.font_size ?? 30;
    // eslint-disable-next-line tap/no-raw-text-js
    this.font_family = model.font_family ?? 'Helvetica';
    this.text_padding = model.text_padding ?? null;
    this.text_color = model.text_color ?? '#000000';
    this.text_bold = model.text_bold ?? false;
    this.text_italic = model.text_italic ?? false;
    this.text_underline = model.text_underline ?? false;
    this.text_strikethrough = model.text_strikethrough ?? false;
    this.text_opacity = model.text_opacity ?? 100;
    this.text_shadow_color = model.text_shadow_color ?? null;
    this.text_shadow_blur = model.text_shadow_blur ?? 5;
    this.text_shadow_x = model.text_shadow_x ?? 0;
    this.text_shadow_y = model.text_shadow_y ?? 0;
  }

  /**
   *
   * @param text
   */
  setText(text) {
    this.text = text;
  }
}
